import React, { useEffect, useState } from 'react';
import { Box, Button, Divider, Grid, Typography, Modal, TextField, CircularProgress, Tooltip, Breadcrumbs, useMediaQuery, useTheme } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomSearchInput from '../common/CustomSearchInput';
import CustomTable from '../common/CustomTable';
import imgPlaceholder from '../../images/img-placeholder.svg';
import editIcon from '../../images/edit-icn.svg';
import deleteIcon from '../../images/delete-icn.svg';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import warningIcon from '../../images/warning-remove-icn.svg';
import { Circle } from '@mui/icons-material';
import { HttpRequest } from '../HttpRequest';
import { SuccessAlert } from '../common/snackbar/success';
import { ErrorAlert } from '../common/snackbar/error';
import secureLocalStorage from 'react-secure-storage';
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ReusableModal from '../common/ReusableModal';


const deleteCategoryModal = {
  borderRadius: "10px", backgroundColor: "#fff", position: 'absolute', top: '40%', left: '50%', transform: 'translate(-50%, -50%)', width: "400px", height: "130px", p: '61px 102px 165px 126px', border: '1px #707070', m: '55px 104px 6.5px 118px'
}
const Categories = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [search, setSearch] = useState('');
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false)
  const handleOpenDeleteCategory = () => { setOpenDeleteCategory(true) }
  const handleCloseDeleteCategory = () => { setOpenDeleteCategory(false) }
  const [parentCategories, setParentCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState("");
  const [successShow, setSuccessShow] = useState({ state: false, message: "" });
  const [errorShow, setErrorShow] = useState({ state: false, message: "" });
  const [dataGridPageSize, setPageSize] = useState(10);
  const [pageState, setPageState] = useState({ isLoading: false, data: [], total: 0, page: 1, pageSize: dataGridPageSize, })

  const navigate = useNavigate();
  const rows = parentCategories;
  const businessNumber = secureLocalStorage.getItem("businessId");
  const handleDeleteCategory = (id) => {
    setOpenDeleteCategory(false);
    HttpRequest({
      method: 'PUT',
      url: `/api/updateCategory`,
      body: {
        categoryState: "Deactivation",
        categoryId: [id]
      },
    }).then((data) => {
      if (data.status === 202) {
        setSuccessShow({ state: true, message: "Category deleted successfully!" })
        getCategories();
        setCategoryToDelete({});
      } else {
        const message = data.response.message;
        setErrorShow({ state: true, message });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: 'Failed to delete category!' })
    });
  }
  const handleRowClick = (event, params) => {
    event.stopPropagation();
    navigate(`/zed_ecommerce/categories/${params?.row?._id}/edit`)
  }
  const columns = [
    {
      field: 'name', headerName: 'Name', flex: isMobile ? 2 : 1.5,
      renderHeader: (params) => {
        return (
          <Box onClick={(event)=>handleRowClick(event,params)} style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}>Name </Box>)
      },
      renderCell: (params) => {
        return (
          <Box onClick={(event)=>handleRowClick(event,params)} style={{ color: "#032541", fontSize: isMobile ? "11px" : "14px", fontWeight: "700", display: 'flex', alignItems: 'center' }}>
            <img src={params?.row?.thumbnail ?? imgPlaceholder} alt='' style={{ width: isMobile ? '30px' : '40px', height: isMobile ? '30px' : '40px', margin: isMobile ? '10px 10px 10px 0' : '20px 20px 20px 0', objectFit: 'contain' }} />
            <Typography style={{ margin: isMobile ? '10px' : '20px', fontWeight: params?.row?.parentCategoryName!==null ? 'normal' : '600', fontSize: isMobile ? "11px" : "14px" }}> {params?.row?.parentCategoryName!==null ? '---' : ''} {params?.row?.categoryName}</Typography>
          </Box>)
      },
    },
    {
      field: 'categoryDescription', headerName: 'Description', flex: isMobile ? 1.5 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Description  </Box>) },
      renderCell: (params) => {
        return (
          <Box onClick={(event)=>handleRowClick(event,params)} style={{ color: "#032541", fontSize: isMobile ? "11px" : "14px", fontWeight: "700", display: 'flex' }}>
            <Typography style={{ margin: isMobile ? '10px 5px' : '20px 10px', fontSize: isMobile ? "11px" : "14px" }}>{params?.row?.categoryDescription}</Typography>
          </Box>)
      }
    },
    {
      field: 'parentCategoryName', headerName: 'Parent Category', flex: isMobile ? 1.2 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Parent Category  </Box>) },
      renderCell: (params) => {
        return (
          <Box onClick={(event)=>handleRowClick(event,params)} style={{ color: "#032541", fontSize: isMobile ? "11px" : "14px", fontWeight: "700", display: 'flex' }}>
            <Typography style={{ margin: isMobile ? '10px' : '20px', fontSize: isMobile ? "11px" : "14px" }}>{params?.row?.parentCategoryName}</Typography>
          </Box>)
      }
    },
    {
      field: 'items', headerName: 'Items', flex: isMobile ? 0.8 : 1,
      renderHeader: (params) => { return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Items  </Box>) },
      renderCell: (params) => {
        return (
          <Box onClick={(event)=>handleRowClick(event,params)} style={{ color: "#032541", fontSize: isMobile ? "11px" : "14px", fontWeight: "700", display: 'flex' }}>
            <Typography style={{ margin: isMobile ? '10px' : '20px', fontSize: isMobile ? "11px" : "14px" }}>-</Typography>
          </Box>)
      }
    },
    {
      field: 'actions', headerName: 'Actions', flex: isMobile ? 1 : 1,
      renderHeader: (params) => {
        return (
          <Box onClick={(event)=>handleRowClick(event,params)} style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}>Actions </Box>)
      },
      renderCell: (params) => {
        const onClickDelete = (event) => {
          event.stopPropagation();
          setCategoryToDelete(params?.row);
          handleOpenDeleteCategory();
        }
        return (
          <Box style={{ color: "#032541", fontSize: isMobile ? "11px" : "14px", fontWeight: "700", display: 'flex', marginTop: isMobile ? '5px' : '0' }}>
            <Tooltip title="Edit">
            <Button onClick={(event)=>handleRowClick(event,params)} style={{ textDecoration: 'none', minWidth: 'auto', padding: isMobile ? '4px' : '8px' }}> 
              <img src={editIcon} alt='' style={{ width: isMobile ? 16 : 20, height: isMobile ? 16 : 20, margin: isMobile ? '0 10px 0 0' : '0 21px 0 0', objectFit: 'contain' }} /> 
            </Button>
            </Tooltip>
            <Tooltip title= "Delete">
            <Button onClick={onClickDelete} style={{ textDecoration: 'none', minWidth: 'auto', padding: isMobile ? '4px' : '8px' }}> 
              <img src={deleteIcon} alt='' style={{ width: isMobile ? 16 : 20, height: isMobile ? 16 : 20, margin: isMobile ? '0 10px 0 0' : '0 21px 0 0', objectFit: 'contain' }} /> 
            </Button>
            </Tooltip>
          </Box>)
      },
    }
  ];
  const getCategories = () => {
    setPageState((old) => ({ ...old, isLoading: true }));
    HttpRequest({
      method: 'GET',
      url: `/api/v1/ecommerce/get_categories?businessNumber=${businessNumber}&page=${pageState.page}&limit=${dataGridPageSize}&categoryName=${search}`
    }).then((data) => {
      const categories = data.response.data;
      const flattenRows = [];

      const flattenCategories = (categories) => {
        const rows = [];

        categories.forEach(category => {
          const row = {
            _id: category._id,
            categoryName: category.categoryName.trim(),
            categoryDescription: category.categoryDescription,
            parentCategoryName: category.parentCategoryName || null,
            items: category.items || '_',
            categoryState: category.categoryState,
            thumbnail: category.thumbnail ?? imgPlaceholder,
            subCategories:category?.subCategories
          };
          rows.push(row);
          if (category.subCategories && category.subCategories.length > 0) {
            const subRows = flattenCategories(category.subCategories);
            rows.push(...subRows);
          }
        });

        return rows;
      };
      categories.forEach(category => {
        const row = {
          _id: category._id,
          categoryName: category.categoryName.trim(),
          categoryDescription: category.categoryDescription,
          parentCategoryName: category.parentCategoryName || null,
          items: category.items || '_',
          categoryState: category.categoryState,
          subCategories:category?.subCategories
        };
        flattenRows.push(row);
        if (category.subCategories && category.subCategories.length > 0) {
          const subRows = flattenCategories(category.subCategories);
          flattenRows.push(...subRows);
        }
      });
      const activeCategories = flattenRows.filter(category => category.categoryState === "Active");
      setParentCategories(activeCategories);
      setPageState((old) => ({
        ...old,
        isLoading: false,
        total: data?.response.count,
        data: activeCategories,
      }));
    }).catch((error) => {
      
    }).finally(() => {
      setLoading(false);

    });
  };


  useEffect(() => {
    getCategories()
  }, [dataGridPageSize, pageState.page, businessNumber,search])

  const breadcrumbs = [
      <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem", ml: isMobile ? 0 : 3 }}>
          Dashboard
      </Typography>,
      <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem" }}>
          Inventory
      </Typography>,
      <Typography key={"add"} sx={{ color: "#dc3545", fontSize: "0.875rem" }}>
          Categories
      </Typography>
  ];
  return (
    <>
      <Box component="main" sx={{ margin: { xs: "15% 0 0 -25px", sm: "4% 0 0 15px" }, padding: { xs: "0px 16px 136px 16px", sm: "0px 34px 136px 0" }, width: { xs: "100vw", sm: "calc(100vw - 370px)" }, maxWidth: "100%", overflowX: "hidden", boxSizing: "border-box"}}>
        <SuccessAlert vertical="top" horizontal="right" onClose={() => setSuccessShow({ ...successShow, state: false })} open={successShow.state} message={successShow.message} />
        <ErrorAlert vertical="top" horizontal="right" onClose={() => setErrorShow({ ...errorShow, state: false })} open={errorShow.state} message={errorShow.message} />
        <Grid container spacing={2} columns={2}>
          <Grid item sx={{ display: 'flex', width: '100%' }} lg={12}>
            <Typography sx={{ fontFamily: 'Poppins', height: '20px', fontSize: { xs: "18px", sm: "28px" }, fontWeight: 600, width: '100%'}}>
              Categories
            </Typography>
          </Grid>
          <Grid item sx={{ display: 'flex', width: '100%', marginLeft:{xs:'-1px', sm:'-20px'} }} mt={1} lg={12}>
            <Breadcrumbs style={{ fontFamily: 'Poppins', fontSize: { xs: "11px", sm: "13px" },  marginBottom: '20px', width: '100%' }} separator={<FiberManualRecordIcon style={{ fontSize: "0.625rem", fontFamily: 'Poppins', color: "#e1e5e8" }} />} aria-label="breadcrumb">
                {breadcrumbs}
            </Breadcrumbs>
          </Grid>
          <Grid item sx={{ display: 'flex', justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, width: '100%', flexDirection: { xs: 'column', sm: 'row' },gap: { xs: 2, sm: 0 }}} lg={12} mt={-4}>
            <Typography sx={{ fontFamily: 'Poppins', fontSize: { xs: "12px", sm: "16px" }, fontWeight: 'normal', color: '#707070', width: { xs: '100%', sm: 'auto' }}}>
              View and manage your product categories.
            </Typography>
            <Button variant='contained' sx={{ backgroundColor: '#032541', textTransform: 'capitalize', textWrap: 'nowrap', "&:hover": { backgroundColor: '#032541' }, width: { xs: '100%', sm: 'auto' }}}>
              <Link to='/zed_ecommerce/addCategories' style={{ textDecoration: 'none', color: '#fff', width: '100%', display: 'block' }}>Add Category</Link>
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item sx={{ display: 'flex', width: '100%' }} lg={12}>
            <CustomSearchInput placeholder="Search" name="search" value={search} onChange={(event)=>setSearch(event.target.value)}sx={{ width: { xs: '100%', sm: 'auto' } }}/>
          </Grid>
          <Grid item lg={12} sx={{ width: '100%' }}>
            <Box sx={{ minHeight: 400, width: '100%', overflowX: 'auto' }}>
              <Box sx={{ minWidth: { xs: 800, sm: '100%' } }}>
              <DataGrid
                sx={{ minHeight: 400, height: 'auto', width: 'auto', fontFamily: 'Poppins', fontSize: isMobile ? '10px' : '12px', color: '#272d3d', boxShadow: 0, border: 0,'& .MuiDataGrid-cell': { fontSize: isMobile ? '10px' : '12px',}}}
                rowCount={pageState.total}
                pagination
                loading={pageState.isLoading}
                page={pageState.page - 1}
                pageSizeOptions={[1, 10, 20, 50, 100]}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: dataGridPageSize,
                      page: pageState.page - 1,
                    },
                  },
                }}
                pageSize={dataGridPageSize}
                onPaginationModelChange={(data) => {
                  const { pageSize, page } = data;
                  setPageState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
                  setPageSize(pageSize)
                }}
                paginationMode="server"
                columns={columns}
                rows={pageState.data}
                getRowId={(row) => row._id}
              />
            </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <ReusableModal open={openDeleteCategory} onClose={handleCloseDeleteCategory}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", pt: 4, px: 3,}}>
          <Box sx={{ mb: 2 }}>
            <img src={warningIcon} alt="warning" width={70} height={70} style={{ objectFit: "contain" }}/>
          </Box>
          <Typography sx={{ color: "#032541", fontFamily: "Poppins", fontWeight: 600, fontSize: { xs: "16px", sm: "18px" }, mb: 1.5, textAlign: "center", }}>
            Delete Category?
          </Typography>
          <Typography sx={{ color: "#707070", fontFamily: "Poppins", fontSize: { xs: "12px", sm: "14px" }, textAlign: "center", mb: 3,}}>
            Selected category will be deleted. <br /> This action cannot be undone.
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", mb: 3, }}>
            <Circle sx={{ width: "10px", height: "10px", color: "#0c253f", mr: 1 }} />
            <Typography sx={{ fontFamily: "Poppins", fontSize: { xs: "14px", sm: "16px" }, color: "#032541", textAlign: "center", }}>
              {categoryToDelete?.categoryName}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <Button sx={{ height: "45px", width: "125px", borderRadius: "4px", backgroundColor: "#dc3545", border: "1px solid #dc3545", color: "#fff", fontWeight: 600, fontSize: "14px", fontFamily: "Poppins", textTransform: "none", "&:hover": { backgroundColor: "#c82333" } }} onClick={() => handleDeleteCategory(categoryToDelete._id)}>
              Delete
            </Button>
          </Box>
        </Box>
      </ReusableModal>
    </>
  );
}

export default Categories;
